/** Colours for telling personas apart, readable on light and dark backgrounds. */
const PALETTE = ["#4f8cff", "#f2994a", "#27ae60", "#bb6bd9", "#eb5757", "#2d9cdb", "#d4a017", "#16a085"];

/** A colour per persona id, given in a stable order (the API lists personas by name). */
export function personaColors(personaIds: string[]): Map<string, string> {
  return new Map(personaIds.map((id, index) => [id, PALETTE[index % PALETTE.length]!]));
}
